import React from 'react';
import { string } from 'prop-types';
import { intlShape } from 'react-intl';
import classNames from 'classnames';
import { pathOr } from 'ramda';

import { propTypes } from '../../../../util/types';

import {getAcceptanceRateValueTextId, getResponseTimeValueTextId} from './ResponseInfo.helpers';
import css from './ResponseInfo.module.css';

const ResponseInfo = (props) => {
  const {
    className,
    intl,
    listing
  } = props;
  const scoreAcceptanceRate = pathOr(null, ['attributes', 'metadata', 'scoreAcceptanceRate'], listing);
  const scoreAcceptanceRateValueTextId = getAcceptanceRateValueTextId(scoreAcceptanceRate);
  const scoreAcceptanceRateValueText = intl.formatMessage({ id: `ListingPage.${scoreAcceptanceRateValueTextId}` })
  const scoreAcceptanceRateText = intl.formatMessage({ id : 'ListingPage.acceptanceRateLabel' });
  const responseInfo = pathOr({}, ['attributes', 'metadata', 'responseInfo'], listing);
  const responseTimeText = intl.formatMessage({ id : 'ListingPage.responseTime' });
  const responseTimeValueTextId = getResponseTimeValueTextId(responseInfo.responseTimeAverage);
  const responseTimeValueText = intl.formatMessage({ id: `ListingPage.${responseTimeValueTextId}` })
  const classes = classNames(css.root, className);

  return (
    <>
      {/*
      <div className={classes}>
        {scoreAcceptanceRateValueTextId && (
          <span className={css.text}>{`${scoreAcceptanceRateText} ${scoreAcceptanceRateValueText}`}</span>
        )}
        {responseTimeValueTextId && (
          <span className={css.text}>{`${responseTimeText} ${responseTimeValueText}`}</span>
        )}
      </div>
      */}
    </>
  )
}

ResponseInfo.defaultProps = {
  className: null,
  listing: null
};

ResponseInfo.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  listing: propTypes.listing
};

export default ResponseInfo;
